// Work queue of the Arrivals "Akce" view (#104): loadings the planner has
// to act on, most urgent first. A loading leaves the queue once its state
// changes (confirmed, rescheduled, …) or the planner marks it as resolved.
import { noShowRisk } from '@/lib/noShowRisk';

const ACTION_STATES = ['no-info', 'no-power'];

export const needsAction = (l) => ACTION_STATES.includes(l.state) && !l.resolved;

export function actionQueue(loadings) {
  return loadings
    .filter(needsAction)
    .map(l => ({ loading: l, risk: noShowRisk(l) }))
    .sort((a, b) => a.loading.plannedAt.localeCompare(b.loading.plannedAt)
      || (b.risk?.score || 0) - (a.risk?.score || 0));
}
